module.exports = __webpack_public_path__ + "img/events-icon.28ee6d73.svg";